<template>
  <smd-one-col-layout content-styles="home__content-styles dark-light-bg">
    <smd-header class="top-bar-box-shadow" slot="header">
      <img alt="nowserving logo"
           class="crisp-image"
           src="../assets/images/nowserving.png"
           slot="left-actions"
           v-if="$isMobile"
           width="123px">

      <h1 class="Title1"
          slot="left-actions"
          v-else>
        {{ `Hi ${this.firstname}!` }}
      </h1>

      <smd-btn class="icon-btn"
               icon="ns-icon-settings"
               slot="right-actions"
               @click="goToSettings">
      </smd-btn>
    </smd-header>
    <div>
      <smd-alert-pane class="mb-m"
                      v-if="error"
                      type="danger">
        <p>{{ error }}</p>
      </smd-alert-pane>

      <div class="smd-form__row"
           v-if="$isMobile">
        <h1 class="Title1">
          {{ `Hi ${this.firstname}!` }}
        </h1>
      </div>

      <on-demand-banner v-if="currentODBooking && showLatestODBooking"
                        :status="currentODBooking.status"
                        :booking-details="currentODBooking"
                        class="mb-m"
                        @hide-banner="updateODBannerDisplay"
                        @click.native="goToODStatusPage"/>

      <babybook-preview v-if="hasBabybookEligiblePatient" class="mb-m"/>

      <div class="priority-appointment mb-m"
           v-if="priorityAppointments && priorityAppointments.length">
        <div class="header">
          <h2 class="Title3 m-b-10">{{ $options.priorityHeaderText[priorityAppointments[0].type] }}</h2>
          <h2 class="section-header"
              v-if="priorityAppointments.length > 1">
            +{{ priorityAppointments.length - 1 }} more
          </h2>
        </div>
        <appointments-doctor-card :appointment="priorityAppointments[0]"
                                  @click.native="goToAppointment(priorityAppointments[0])"/>
      </div>

      <div :class="!$isMobile ? 'smd-form__row': 'smd-form__col'">
        <div class="smd-form__row">
          <div class="smd-form__col">
            <smd-card class="home-card home-card--doctor"
                      v-bind="$options.doctorCardProps"
                      @card-clicked="findDoctors"/>
          </div>
        </div>
        <div class="smd-form__row">
          <div class="smd-form__col">
            <smd-card class="home-card home-card--invite"
                      v-bind="$options.inviteCodeCardProps"
                      @card-clicked="showInviteCodeForm"/>
          </div>
        </div>
      </div>
      <div class="smd-form__row">
        <div class="smd-form__col">
          <h2 class="section-header Title1">Explore</h2>
        </div>
      </div>
      <div class="smd-form__row">
        <div class="smd-form__col">
          <smd-card class="home-card home-card--booking"
                    v-bind="$options.followBookingProps"
                    @card-clicked="showBookingInstructions"/>
        </div>
        <div class="smd-form__col" v-if="false">
          <smd-card-square v-bind="$options.medicineDeliverProps"
                           @card-clicked="showHowToDeliverMedicine"/>
        </div>
      </div>
      <div class="smd-form__row" v-if="false">
        <div class="smd-form__col">
          <smd-card v-bind="$options.testCallProps"
                    @card-clicked="doTestCall"/>
        </div>
      </div>
    </div>
  </smd-one-col-layout>
</template>

<script>
  import {mapGetters, mapActions} from 'vuex';
  import {Reference} from 'smd-vue-scaffold';
  import {getAccountWithDetailsService} from '@/services/account';
  import {extractDateStringOnIsoString} from '@/utils';
  import {goToAppointment} from '@/utils/appointments';
  import {APPOINTMENT_TYPES} from '@/constants';
  import {bus} from '@/main';
  import {HANDLE_SHARED_FILE, CLAIM_PROFILE_VERIFIED} from '@/constants/bus';

  import DoctorCard from '@/assets/images/doctor-card.png';
  import InviteCode from '@/assets/images/invite-code.png';
  import BookingInstruction from '@/assets/images/booking-instructions.png';
  import MedicineDeliver from '@/assets/images/medicine-deliver.png';
  import DoTestCall from '@/assets/images/do-test-call.png';
  import InviteCodeModal from '@/components/InviteCodeModal';
  import StepsModal from '@/components/StepsModal';
  import ClaimRecordsModal from '@/components/clinic-qr/claim-records-modal';
  import BabybookPreview from '@/components/clinic-qr/babybook-preview';
  import HeaderFunctionMixin from '@/mixins/header-functions-mixin'
  import OnDemandMixin from '@/mixins/ondemand-mixin';

  import AppointmentsDoctorCard from '@/components/appointments-doctor-card';
  import SelectDoctor from '@/assets/images/booking/select-doctor.png';
  import FillUpForm from '@/assets/images/booking/fill-up-form.png';
  import EnterOtp from '@/assets/images/booking/enter-otp.png';
  import BookingFees from '@/assets/images/booking/booking-fees.png';
  import WaitForConfirmation from '@/assets/images/booking/wait-for-confirmation.png';

  import GoToFiles from '@/assets/images/medicine-order/go-to-files.png';
  import SelectPrescription from '@/assets/images/medicine-order/select-prescription.png';
  import ChoosePharmacy from '@/assets/images/medicine-order/choose-a-pharmacy.png';
  import EnterOrderDetails from '@/assets/images/medicine-order/enter-order-details.png';
  import WaitForCall from '@/assets/images/medicine-order/wait-for-call.png';
  import ReceiveAndPayOrder from '@/assets/images/medicine-order/receive-and-pay-order.png';
  import Routes from '@/router/routes';

  import OnDemandBanner from '@/components/banners/ondemand/root-ondemand-banner.vue';

  const ACCOUNT_SETTING_BTN_ID = 'ACCOUNT_SETTING';

  import {
    GETTER_FILES_FETCHING,
    GETTER_FIRSTNAME,
    GETTER_MOBILENUMBER,
    GETTER_PRIORITY_APPOINTMENTS,
    GETTER_INVITE_CODE_URL_TOKEN,
    GETTER_ONDEMAND_LATEST_BOOKING,
    GETTER_SHOW_LATEST_BOOKING_BANNER,
    ACTION_EDIT_ACCOUNT,
    GETTER_TOKENS,
    ACTION_REMOVE_INVITE_CODE_TOKEN,
    ACTION_REFRESH_APPOINTMENTS,
    ACTION_SHOW_TOAST,
    ACTION_SET_HIDDEN_OD_BOOKING_ID,
    ROUTING_QUERY,
    GETTER_CLINIC_QR_DOCTOR_TOKEN,
    ACTION_CLEAR_CLINIC_QR_DOCTOR_TOKEN,
    GETTER_BABYBOOK_WHITELIST,
    ACTION_FETCH_BABYBOOK_WHITELIST,
  } from '@/store/types';

  export default {
    name: 'Home',
    mixins: [
      HeaderFunctionMixin,
      OnDemandMixin,
    ],
    components: {
      AppointmentsDoctorCard,
      BabybookPreview,
      OnDemandBanner,
    },
    data() {
      return {
        error: null,
        hideODBanner: false,
      };
    },
    computed: {
      ...mapGetters({
        firstname: GETTER_FIRSTNAME,
        mobilenumber: GETTER_MOBILENUMBER,
        priorityAppointments: GETTER_PRIORITY_APPOINTMENTS,
        getInviteCodeToken: GETTER_INVITE_CODE_URL_TOKEN,
        getTokensArray: GETTER_TOKENS,
        isFilesFetching: GETTER_FILES_FETCHING,
        currentODBooking: GETTER_ONDEMAND_LATEST_BOOKING,
        routeQueryState: ROUTING_QUERY,
        showLatestODBooking: GETTER_SHOW_LATEST_BOOKING_BANNER,
        clinicQrDoctorToken: GETTER_CLINIC_QR_DOCTOR_TOKEN,
        babybookWhitelistedTokens: GETTER_BABYBOOK_WHITELIST,
      }),
      leftHeader() {
        return [{label: `Hi ${this.firstname}!`, route: ''}];
      },
      hasBabybookEligiblePatient() {
        if (!Array.isArray(this.getTokensArray)) return false;
        if (!Array.isArray(this.babybookWhitelistedTokens)) return false;
        return this.getTokensArray.some((token) => {
          if (!token || !this.babybookWhitelistedTokens.includes(token.token)) return false;
          const birthdate = token.patient && token.patient.birthdate;
          return this.isBabybookAge(birthdate);
        });
      },
    },
    watch: {
      getInviteCodeToken: {
        handler(newToken) {
          if (newToken) {
            this.showInviteCodeForm();
          }
        },
        immediate: true,
      },
      clinicQrDoctorToken: {
        handler(newToken) {
          if (newToken) {
            this.showClinicQrClaimModal();
          }
        },
        immediate: true,
      },
      isFilesFetching: {
        handler(val) {
          if (!val && !this.getInviteCodeToken) this.handleViewingSharedFileFromInvite(!!this.getInviteCodeToken);
        },
        immediate: true,
      },
      getTokensArray: {
        handler(tokens) {
          if (Array.isArray(tokens) && tokens.length > 0) {
            this.fetchBabybookWhitelist();
          }
        },
        immediate: true,
      },
    },
    created() {
      bus.$on(CLAIM_PROFILE_VERIFIED, this.handleClaimVerified);
    },
    beforeDestroy() {
      bus.$off(CLAIM_PROFILE_VERIFIED, this.handleClaimVerified);
    },
    methods: {
      ...mapActions({
        editAccount: ACTION_EDIT_ACCOUNT,
        removeInviteCodeToken: ACTION_REMOVE_INVITE_CODE_TOKEN,
        refreshAppointments: ACTION_REFRESH_APPOINTMENTS,
        showToast: ACTION_SHOW_TOAST,
        setHiddenODBookingId: ACTION_SET_HIDDEN_OD_BOOKING_ID,
        clearClinicQrDoctorToken: ACTION_CLEAR_CLINIC_QR_DOCTOR_TOKEN,
        fetchBabybookWhitelist: ACTION_FETCH_BABYBOOK_WHITELIST,
      }),
      clearInviteToken() {
        this.removeInviteCodeToken();
      },
      isBabybookAge(birthdate) {
        if (!birthdate) return false;
        const dob = new Date(birthdate);
        if (Number.isNaN(dob.getTime())) return false;
        const years = (Date.now() - dob.getTime()) / (1000 * 60 * 60 * 24 * 365.25);
        return years >= 0 && years <= 18;
      },
      async handleClaimVerified() {
        await this.refreshAccountDetails();
        await this.fetchBabybookWhitelist({force: true});
      },
      rightMenuClicked(id) {
        if (id === ACCOUNT_SETTING_BTN_ID) {
          this.$router.push({name: Routes.ACCOUNT_ROUTE});
        }
      },
      goToAppointment,
      handleViewingSharedFileFromInvite(isForNewToken = false) {
        const {_context, uploadid} = this.routeQueryState || {};

        if (_context === Routes.INVITE_CODE_ROUTE && uploadid) {
          bus.$emit(HANDLE_SHARED_FILE, {
            uploadid: this.routeQueryState.uploadid,
            isForNewToken,
          });
        }
      },
      showClinicQrClaimModal() {
        this.$modal.open({
          component: ClaimRecordsModal,
          size: Reference.SmdModalSizes.md,
          position: this.$isMobile ? '' : 'detached',
          dismissable: false,
          escapable: false,
          closeOnBackdrop: false,
          onClose: () => {
            this.clearClinicQrDoctorToken();
          },
        });
      },
      showInviteCodeForm() {
        const props = {
          mobileNumber: this.mobilenumber,
          initialToken: this.getInviteCodeToken,
        };

        this.$modal.open({
          component: InviteCodeModal,
          size: Reference.SmdModalSizes.xs,
          position: 'detached auto-height',
          props,
          onClose: (success) => {
            if (success) {
              this.refreshAccountDetails()
                .then(() => {
                  if (props.initialToken) this.handleViewingSharedFileFromInvite(!!props.initialToken);
                  return this.fetchBabybookWhitelist({force: true});
                });
              // this.showToast('Verification Success.');
              this.showToast({text: 'Verification Success.'});
            }
            this.clearInviteToken();
          },
        });
      },
      async refreshAccountDetails() {
        this.error = null;

        try {
          const data = await getAccountWithDetailsService();

          this.editAccount({
            firstname: data.firstname,
            middlename: data.middlename,
            lastname: data.lastname,
            birthdate: extractDateStringOnIsoString(data.birthdate),
            mobilenumber: data.mobilenumber,
            email: data.email,
            tokens: data.tokens,
          });
        } catch (error) {
          this.error = 'Failed to fetch patient account. Please try refreshing the page.';
        }

        this.refreshAppointments();
      },
      findDoctors() {
        window.open('https://nowserving.ph/', '_blank');
      },
      showBookingInstructions() {
        this.$modal.open({
          component: StepsModal,
          size: Reference.SmdModalSizes.sm,
          position: 'detached auto-height',
          props: {
            header: 'Booking Instructions',
            steps: [
              {
                image: SelectDoctor,
                step: 'Select a Doctor',
                description: 'Choose from your list of doctors or find a new doctor.',
              },
              {
                image: FillUpForm,
                step: 'Fill up Form',
                description: 'Select whether you are new or existing patient, choose schedule, and fill out all the details.',
              },
              {
                image: EnterOtp,
                step: 'Enter OTP',
                description: 'A one-time-pin will be sent to your mobile number to verify your account.',
              },
              {
                image: BookingFees,
                step: 'Booking Fees',
                description: 'Payment can be done through different payment channels or during consult, depending on the doctor\'s preference.',
              },
              {
                image: WaitForConfirmation,
                step: 'Wait for Confirmation',
                description: 'Consultation Status will be updated once your request has been confirmed. You\'ll also be notified through SMS or Email.',
              },
            ],
            button: {
              text: 'Book a Consultation Now',
              func: () => {
                this.$router.push({name: Routes.DOCTORS_ROUTE});
              },
            },
          },
        });
      },
      showHowToDeliverMedicine() {
        this.$modal.open({
          component: StepsModal,
          size: Reference.SmdModalSizes.sm,
          position: 'detached auto-height',
          props: {
            header: 'How it Works',
            subHeader: 'Paano bumili ng gamot',
            steps: [
              {
                image: GoToFiles,
                step: 'Go to Files',
                description: 'Pumunta sa Files',
              },
              {
                image: SelectPrescription,
                step: 'Select Prescription and tap Order',
                description: 'Piliin ng Reseta at pindutin and Order',
              },
              {
                image: ChoosePharmacy,
                step: 'Choose a Pharmacy',
                description: 'Pumili ng Parmasya',
              },
              {
                image: EnterOrderDetails,
                step: 'Enter Order Details',
                description: 'Ilagay ang Detalye ng Order',
              },
              {
                image: WaitForCall,
                step: 'Wait for a Call',
                description: 'Hintayin ang Tawag',
              },
              {
                image: ReceiveAndPayOrder,
                step: 'Receive and Pay Order',
                description: 'Tanggapin at Bayaran ang Order',
              },
            ],
            button: {
              text: 'Go To Files Now',
              func: () => {
                console.log('go to files now');
              },
            },
          },
        });
      },
      doTestCall() {
        console.log('doTestCall');
      },
      goToODStatusPage() {
        this.$router.push({
          name: Routes.ONDEMAND_ROOT,
          params: {bookingID: this.currentODBooking._id},
        });
      },
      updateODBannerDisplay() {
        this.setHiddenODBookingId(this.currentODBooking._id);
      },
      onODBookingAccept({requestid}) {
        if (requestid) {
          this.fetchOnDemandBookings();
        }
      },
      onODBookingReject({requestid}) {
        if (requestid) {
          this.fetchOnDemandBookings();
        }
      },
    },
    headerRightContents: [
      {
        id: ACCOUNT_SETTING_BTN_ID,
        icon: 'ns-icon-settings',
      },
    ],
    doctorCardProps: {
      header: 'Need a Doctor?',
      text: 'Find the right one for you',
      textColor: '#30328b',
      clickable: true,
      image: DoctorCard,
    },
    inviteCodeCardProps: {
      header: 'Got an Invite Code?',
      text: 'Enter it manually',
      textColor: '#066c15',
      clickable: true,
      image: InviteCode,
    },
    followBookingProps: {
      header: 'Booking Instructions',
      text: 'Simple steps to book your consultation',
      textColor: '#616282',
      clickable: true,
      image: BookingInstruction,
    },
    medicineDeliverProps: {
      header: 'Medicine to your doorstep',
      preHeaderText: 'We Deliver',
      preHeaderColor: '#736fdc',
      clickable: true,
      image: MedicineDeliver,
    },
    testCallProps: {
      header: 'Do a Test Call',
      text: 'Test your device, connection, microphone, and camera.',
      borderColor: '#e1e1e1',
      backgroundColor: '#ffffff',
      clickable: true,
      image: DoTestCall,
    },
    priorityHeaderText: {
      [APPOINTMENT_TYPES.NOW]: 'Your Consultation Today',
      [APPOINTMENT_TYPES.FUTURE]: 'Your Future Consultation',
      [APPOINTMENT_TYPES.PENDING]: 'Your Pending Consultation',
      [APPOINTMENT_TYPES.DENIED]: 'Your Denied Consultation',
    },
  }
</script>

<style lang="scss">
  .priority-appointment {
    .header {
      display: flex;
      justify-content: space-between;

      h2:first-child {
        margin-right: space(m);
      }
    }
  }

  .home-card {
    &.smd-card {
      @include border-radius(20px);
      @include space-me($t: m, $r: m, $b: m, $l: m-base);

      .text-section {
        h3 {
          @extend %smd-font-family-bold;
          font-size: font(l) - 1;
          line-height: 1.1;
          margin-bottom: space(xs);
          text-transform: none;
        }

        p {
          font-size: font(base);
          line-height: 20px;
          text-transform: none;
        }
      }

      .image {
        @include space-me($prop: margin, $l: s);
        width: 100px;
        height: 70px;
      }

      &.home-card--invite {
        background: linear-gradient(50.48deg, #d3ffda 9.91%, #a9f8b5 65.65%, #59de6d 97.69%) !important;

        .text-section h3 {
          color: #065111;
        }
      }

      &.home-card--doctor {
        background: linear-gradient(56.37deg, #e2f3ff 9.91%, #b3dfff 65.65%, #73c5ff 97.69%) !important;

        .text-section h3 {
          color: #24266e;
        }
      }

      &.home-card--booking {
        box-shadow: 0 0 7.5px rgba(64, 61, 136, 0.1);

        .text-section h3 {
          color: #262637;
        }
      }
    }
  }

  .home__content-styles {
    > div {
      @include set-max-width();
    }

    @include responsive('min-width: 1024px') {
      padding: space(xxl) !important;

      .smd-form--search {
        max-width: 792px;
      }
    }
  }
</style>
